import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { styled } from '@mui/material';
import axios from 'axios';
import {
    addDays,
    compareAsc,
    compareDesc,
    format,
    parseISO,
    subDays,
} from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ErrorLoading from '../components/BasicComponents/ErrorLoading';
import HistoryTable from '../components/HistoryTable';
import Loading from '../components/Loading';
import Title from '../components/Navbar/Title';
import ProfileWarning from '../components/Profile/ProfileWarning';
import { updateStatus as updateAvailStatus } from '../redux/AvailabilitySlice';
import {
    fetchSchoolBooking,
    fetchTeacherBooking,
    updateStatus,
} from '../redux/BookingSlice';
import SignSchoolDocs from '../components/BasicComponents/SignSchoolDocs';

const validPermission = 'read:booking';

const RootDiv = styled('div')(({ theme }) => ({
    padding: '30px 20px 40px',
}));

export const History = () => {
    // const classes = useStyles();
    let history = useHistory();

    const [state, setState] = useState({
        grade: '',
        address: '',
        teacherName: '',
        teacherProfile: '',
        skills: '',
        otherSkills: '',
        bio: '',
        addDates: '',
        value1: false,
        value2: true,
        openSnack: false,
        snackBarMessage: '',
        snackSeverity: 'success',
        startDate: format(subDays(Date.now(), 60), 'yyyy-MM-dd'),
        endDate: format(addDays(Date.now(), 60), 'yyyy-MM-dd'),
    });

    const [redirectToHome, setRedirectToHome] = useState(false);

    const [countDown, setCountDown] = useState(20);

    //0 === not applied, 1 === postive, 2 === negative
    // const [dateSort, setDateSort] = useState(1);
    // const [statusSort, setStatusSort] = useState(0);
    // const [schoolSort, setSchoolSort] = useState(0);
    const { booking } = useSelector(state => state.booking);
    const bookingStatus = useSelector(state => state.booking.status);
    const bookingSource = useSelector(state => state.booking.bookingSource);

    const profile = useSelector(state => state.profile.profile);
    const tokenStatus = useSelector(state => state.token.status);
    const profileStatus = useSelector(state => state.profile.status);
    const { token } = useSelector(state => state.token);
    const dispatch = useDispatch();
    const { getAccessTokenSilently } = useAuth0();

    const [signDocsOpen, setSignDocsOpen] = useState(false);
    const [schoolDocsInfo, setSchoolDocsInfo] = useState({});
    const [cached, setCached] = useState({});

    useEffect(() => {
        //useEffect is completed on page load
        //Service to get the profile for a user
        console.log(
            'status of profile ' + profileStatus + ' ' + profile.Data.Count
        );
        // if (profileStatus === 'idle') {
        //     async function dispatchProfileFromStore() {
        //         const token = await getAccessTokenSilently({
        //             scope: process.env.REACT_APP_scope,
        //         });

        //         dispatch(storeToken(token));
        //         dispatch(fetchProfile(token));
        //     }
        //     dispatchProfileFromStore();
        // }
        if (profileStatus === 'succeeded' && profile.Data.Count === 0) {
            setRedirectToHome(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getAccessTokenSilently, profileStatus, dispatch]);

    useEffect(() => {
        if (tokenStatus === 'succeeded' && token.Count === 1) {
            if (token.permissions.includes(validPermission) === false)
                setRedirectToHome(true);
        }
    }, [tokenStatus, token.Count, token.permissions]);
    async function dispatchBookingFromStore(scope, type) {
        const token = await getAccessTokenSilently({
            scope: scope,
        });
        if (type === 'Teacher') {
            dispatch(
                fetchTeacherBooking({
                    token: token,
                    status1: 'Pending',
                    status2: 'Approved',
                    location: 'Actions',
                })
            );
        } else if (type === 'School') {
            dispatch(
                fetchSchoolBooking({
                    token: token,
                    status1: 'Approved',
                    status2: 'Completed',
                    location: 'Actions',
                })
            );
        }
    }
    useEffect(() => {
        if (bookingSource !== 'Actions' && profile.Data.Count > 0) {
            dispatchBookingFromStore(
                process.env.REACT_APP_scope,
                profile.Data.Items[0].type
            );
        }
        //Service to get the availability for specific geohash and date
        //console.log(JSON.stringify(profile.profile));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile.Data.Count, bookingSource]);

    useEffect(() => {
        console.log('run x times');
        if (redirectToHome) {
            setTimeout(() => {
                var interimNumber = countDown - 1;
                setCountDown(interimNumber);
            }, 1000);
        }
    }, [redirectToHome, countDown]);

    let actionRows = [];
    if (profileStatus === 'succeeded') {
        if (profile.Data.Items[0].type === 'School') {
            actionRows = booking.Data.filter(item => {
                if (
                    //to give rating
                    (item.status === 'Complete' &&
                        compareAsc(parseISO(item.endDate), Date.now()) === -1 &&
                        typeof item.schoolComments === 'undefined') ||
                    //to upload documents
                    (item.status === 'Approved' &&
                        typeof item.schoolUploadText === 'undefined' &&
                        compareAsc(parseISO(item.startDate), Date.now()) ===
                            1) ||
                    item.status === 'Completed'
                ) {
                    return item;
                }
                //return booking.Data;
            });
        } else if (profile.Data.Items[0].type === 'Teacher') {
            actionRows = booking.Data.filter(item => {
                if (
                    (item.status === 'Pending' &&
                        compareDesc(parseISO(item.endDate), Date.now()) ===
                            -1) ||
                    item.status === 'Complete' ||
                    item.status === 'Processing' ||
                    (item.status === 'Approved' &&
                        compareDesc(parseISO(item.endDate), Date.now()) === 1 &&
                        typeof item.teacherFeedback === 'undefined')
                ) {
                    return item;
                }
                //return booking.Data;
            });
        }
    }

    const confirmBooking = async (event, approve, row) => {
        if (event === undefined) {
            event = cached.event;
            approve = cached.approve;
            row = cached.row;
        }

        event.stopPropagation();
        console.log('index item ' + JSON.stringify(row));
        const originalStatus = row.status;
        let changeStatus = { status: 'Processing', id: row.uniqueId };
        dispatch(updateStatus(changeStatus));

        // setState({
        //     ...state,
        //     loading: false,
        //     booking: interimBooking,
        // });
        const token = await getAccessTokenSilently({
            scope: process.env.REACT_APP_scope,
        });
        const data = {
            'request': { 'approve': approve.toString(), 'date': row.sk1 },
        };

        const response = await axios
            .put('/confirmBooking', data.request, {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                url: '/confirmBooking',
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            .then(response => {
                changeStatus.status = response.data.Message.Data.bookingStatus;

                dispatch(updateStatus(changeStatus));

                try {
                    const availStatus = {
                        status: response.data.Message.Data.availStatus,
                        id: response.data.Message.Data.availUniqueId,
                    };
                    dispatch(updateAvailStatus(availStatus));
                } catch {
                    console.log('Availability not in memory');
                }

                if (response.data.Message.Code === 'Awaiting Sign') {
                    setSchoolDocsInfo({
                        docs: response.data.Message.Data.results,
                        logo: row.schoolLogo,
                        name: row.schooName,
                    });
                    setSignDocsOpen(true);
                    setCached({
                        event: event,
                        approve: approve,
                        row: row,
                    });
                } else {
                    setState({
                        ...state,
                        snackBarMessage: 'Booking Updated',
                        openSnack: true,
                        snackSeverity: 'success',
                    });
                }
            })
            .catch(err => {
                changeStatus.status = originalStatus;
                dispatch(updateStatus(changeStatus));
                console.log('Alert Customer of Failure');

                setState({
                    ...state,
                    snackBarMessage: 'Booking Failed to Update',
                    openSnack: true,
                    snackSeverity: 'error',
                });
            });
        console.log('Response from API ' + JSON.stringify(response));
    };

    const navigateToDetails = uniqueId => {
        if (profile.Data.Items[0].type === 'Teacher') {
            history.push('/history/teacher-booking/' + uniqueId);
        } else {
            history.push('/history/school-booking/' + uniqueId);
        }
    };

    let content;

    if (bookingStatus === 'loading' || profileStatus === 'idle') {
        content = <Loading />;
    } else if (redirectToHome) {
        content = (
            <ProfileWarning
                message="You will not have any actions until your profile
        is verified"
                redirectTime={countDown}
            />
        );
    } else if (bookingStatus === 'succeeded' && profile.Data.Count > 0) {
        content = (
            <HistoryTable
                title="Actions Required"
                rows={actionRows}
                confirmBooking={confirmBooking}
                navigateToDetails={navigateToDetails}
                type={profile.Data.Items[0].type}
                snackBarMessage={state.snackBarMessage}
                openSnack={state.openSnack}
                snackSeverity={state.snackSeverity}
            />
        );
    } else if (
        bookingStatus === 'error' ||
        (bookingStatus === 'failed' && profile.Data.Count > 0)
    ) {
        content = (
            <ErrorLoading
                text="Error Loading Bookings"
                type={profile.Data.Items[0].type}
                dispatchCall={() =>
                    dispatchBookingFromStore(
                        process.env.REACT_APP_scope,
                        profile.Data.Items[0].type
                    )
                }
            />
        );
    }

    return (
        <div>
            <Title title="Actions" />
            <RootDiv>{content}</RootDiv>
            {signDocsOpen && (
                <SignSchoolDocs
                    setOpen={setSignDocsOpen}
                    schoolDocsInfo={schoolDocsInfo}
                    setSnack={data => {
                        setState({
                            ...state,
                            openSnack: data.openSnack,
                            snackBarMessage: data.snackBarMessage,
                            snackSeverity: data.snackSeverity,
                        });
                    }}
                    confirmBooking={confirmBooking}
                />
            )}
        </div>
    );
};

export default withAuthenticationRequired(History, {
    onRedirecting: () => <Loading />,
});
